'use strict';

module.exports = (errorMessage) => {
    return {
        namespaced: true,
        state: { errorMessage: errorMessage},
        mutations: {
            setErrorMessage(state, newMessage) {
                state.errorMessage = newMessage;
            },
            removeErrorMessage(state, message) {
                if (state.errorMessage === message) {
                    state.errorMessage = null;
                }
            }
        }
    };
};

